import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Component({
  selector: 'app-warning-data-authentication',
  templateUrl: './warning-data-authentication.component.html',
  styles: [`
    .info-branch {
      font-family: Roboto, "Helvetica Neue", sans-serif;
    }
  `]
})

export class WarningDataAuthenticationComponent implements OnInit {
  safeMessage: SafeHtml;
  statusDocument: any;
  constructor(
    public dialogRef: MatDialogRef<WarningDataAuthenticationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private location: Location
  ) {
    dialogRef.disableClose = true;
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(data.message);
    this.statusDocument = data.statusDocument;
  }

  ngOnInit() {}

  onNoClick() {
    this.dialogRef.close(false);
    if (this.statusDocument == 4) return;
    if (this.location.path().includes('view-document-moha')) {
      this.location.back();
    }
  }
}
